// apiClient.js
import axios from 'axios';

// export const baseurl = 'https://salesroutephase2.technaureus.com/'; 
// export const baseurl = 'http://127.0.0.1:8000/';

// const apiClient = axios.create({
//   baseURL: baseurl,
//   timeout: 10000,
// });

// let isRefreshing = false;
// let refreshSubscribers = [];

// const subscribeTokenRefresh = (callback) => refreshSubscribers.push(callback);
// const onTokenRefreshed = (token) => {
//   refreshSubscribers.forEach(callback => callback(token));
//   refreshSubscribers = [];
// };

// const isTokenExpired = (token) => {
//   if (!token) return true;
//   try {
//     const { exp } = JSON.parse(atob(token.split('.')[1]));
//     return Date.now() >= exp * 1000;
//   } catch {
//     return true;
//   }
// };

// const refreshAuthToken = async () => {
//   const refreshToken = localStorage.getItem('refreshToken');
//   if (!refreshToken) return null;

//   try {
//     const { data } = await axios.post(`${baseurl}accounts/token/refresh/`, { refresh: refreshToken });
//     localStorage.setItem('accessToken', data.access);
//     if (data.refresh) localStorage.setItem('refreshToken', data.refresh);
//     return data.access;
//   } catch (error) {
//     if (error.response?.status === 401) {
//       localStorage.clear();
//       window.location.href = '/login';
//     }
//     return null;
//   }
// };

// apiClient.interceptors.request.use(async (config) => {
//   let token = localStorage.getItem('accessToken');
//   if (token && isTokenExpired(token)) token = await refreshAuthToken();
//   if (token) config.headers['Authorization'] = `Bearer ${token}`;
//   return config;
// }, Promise.reject);

// apiClient.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;
//     if (error.response?.status === 401 && !originalRequest._retry) {
//       if (isRefreshing) {
//         return new Promise(resolve => {
//           subscribeTokenRefresh(token => {
//             originalRequest.headers['Authorization'] = `Bearer ${token}`;
//             resolve(apiClient(originalRequest));
//           });
//         });
//       }

//       originalRequest._retry = true;
//       isRefreshing = true;

//       try {
//         const newToken = await refreshAuthToken();
//         isRefreshing = false;
//         if (newToken) {
//           onTokenRefreshed(newToken);
//           originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
//           return apiClient(originalRequest);
//         }
//       } catch {
//         isRefreshing = false;
//         throw error;
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default apiClient;


export const baseurl = 'https://salesroutephase2.technaureus.com/'; 
// export const baseurl = 'http://127.0.0.1:8000/'
// export const baseurl = "https://salesroute.ai/";

const apiClient = axios.create({
    baseURL: baseurl,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Add a request interceptor to include token
apiClient.interceptors.request.use(
    async (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


// Add a response interceptor to handle token refresh
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // If error is 401 and we haven't tried refreshing yet
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const refreshToken = localStorage.getItem('refreshToken');
                const response = await axios.post(`${baseurl}accounts/token/refresh/`, {
                    refresh: refreshToken
                });

                const { access } = response.data;
                localStorage.setItem('accessToken', access);

                // Retry the original request with new token
                originalRequest.headers['Authorization'] = `Bearer ${access}`;
                return apiClient(originalRequest);
            } catch (refreshError) {
                // If refresh token is invalid, logout user
                localStorage.clear();
                window.location.href = '/login';
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default apiClient;
